/** True when bundled/served by Vite (TanStack Router runtime). */
export const isViteRuntime =
  typeof import.meta !== 'undefined' &&
  typeof import.meta.env?.MODE === 'string'

/**
 * Heurística de WebView por user agent: apps in-app conhecidos, WebView
 * Android (`; wv)` ou `Version/` sem `Chrome/`) e WKWebView pura no iOS
 * (sem o token `Safari`). Navegadores de terceiros no iOS (CriOS/FxiOS/
 * EdgiOS) anunciam `Safari/` no UA e ficam fora, como devem.
 */
export const isProbablyWebViewUA = (uaRaw?: string): boolean => {
  const ua = (uaRaw || '').trim()
  if (!ua) return false
  const inApp =
    /\b(FBAN|FBAV|Instagram|Line|Twitter|MicroMessenger|Messenger|Snapchat)\b/i.test(
      ua
    )
  const isAndroid = /Android/i.test(ua)
  const androidWV =
    /; wv\)/i.test(ua) ||
    (isAndroid && /Version\/\d+\.\d+/i.test(ua) && !/Chrome\/\d+/i.test(ua))
  const isiOS = /(iPhone|iPad|iPod)/i.test(ua)
  const iOSWV = isiOS && !/Safari/i.test(ua)
  return inApp || androidWV || iOSWV
}

/**
 * Apenas bridges que o app nativo realmente injeta. `window.webkit
 * .messageHandlers` NÃO serve como pista: Chrome/Firefox/Edge no iOS são
 * shells de WKWebView e expõem esse objeto para handlers internos deles —
 * tratá-lo como WebView nativa prendia o Chrome iOS no spinner de auth.
 */
export const hasNativeAppBridge = (w: unknown): boolean => {
  if (!w || typeof w !== 'object') return false
  const win = w as { ReactNativeWebView?: unknown; Android?: unknown }
  return Boolean(win.ReactNativeWebView) || Boolean(win.Android)
}
